import React from 'react';

import { useTranslation } from 'src/i18n';
import { SegmentedToggle } from 'src/component/ds/ui/segmentedToggle';
import type { DeviceNavTab } from 'src/service/api/deviceNav';
import { DEVICE_NAV_TABS } from './deviceNavState';

interface DeviceNavTabsProps {
  value: DeviceNavTab;
  onChange: (tab: DeviceNavTab) => void;
}

export default function DeviceNavTabs ({ value, onChange }: DeviceNavTabsProps) {
  const { t } = useTranslation();

  return (
    <SegmentedToggle
      aria-label={t('deviceNav.label')}
      options={DEVICE_NAV_TABS.map((tab) => ({ value: tab, label: t(`deviceNav.tab.${tab}`) }))}
      value={value}
      onChange={(tab) => onChange(tab as DeviceNavTab)}
      className='ds-w-full [&>*]:ds-grow'
    />
  );
}
